module.exports = __webpack_public_path__ + "static/media/logo_ibc.bd592664.png";